import { render } from "./welIcon.vue?vue&type=template&id=10142677&scoped=true"
import script from "./welIcon.vue?vue&type=script&lang=js"
export * from "./welIcon.vue?vue&type=script&lang=js"

import "./welIcon.vue?vue&type=style&index=0&id=10142677&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10142677"]])

export default __exports__